import type { MouseEvent } from 'react';

import { Download } from '@mint-lib/icons';
import { Button } from '@mint-lib/tw-components';

import { useAiHubPermissions } from '../../../hooks/useAiHubPermissions.jsx';

type Props = {
  handleDownloadFile: () => void;
  variant?: 'plain' | 'text';
  size?: 'small' | 'large';
};

const DownloadButton = ({
  handleDownloadFile,
  variant = 'plain',
  size = 'small',
}: Props) => {
  const { canDownloadReport } = useAiHubPermissions();
  const handleDownload = (e: MouseEvent<HTMLButtonElement>) => {
    e.stopPropagation();
    handleDownloadFile();
  };

  return (
    <Button
      aria-label="download-report-btn"
      variant={variant}
      size={size}
      className="cursor-pointer"
      onClick={handleDownload}
      disabled={!canDownloadReport}
    >
      <Download />
    </Button>
  );
};

export { DownloadButton };
